import {
  composeRecordTitle,
  INDEXING_SEPARATOR,
  normalizeIndexerText,
  RECORD_TITLE_CODE_SEPARATOR,
} from '@record-fill';

// The server form carries the bare prefix ("50.17"); the screens show it as "RQ50.17", the same
// spelling the backend prints for a generated record code.
const MATRIX_CODE_LABEL = 'RQ';

const FILE_NAME_MAX_LENGTH = 150;
const FORBIDDEN_FILE_NAME_CHARACTERS = new Set(['\\', '/', ':', '*', '?', '"', '<', '>', '|']);

export interface RecordTitleSource {
  code: string;
  name: string;
}

export function formatMatrixCode(prefix: string): string {
  return `${MATRIX_CODE_LABEL}${prefix}`;
}

export function buildPendingRecordTitle(prefix: string, indexer: string | null): string | null {
  const text = normalizeIndexerText(indexer ?? '');
  return text === '' ? null : composeRecordTitle(formatMatrixCode(prefix), text);
}

export function recordTitleOf(record: RecordTitleSource): string {
  return record.name.trim() === '' ? record.code : record.name;
}

function isFileNameCharacter(character: string): boolean {
  const code = character.codePointAt(0) ?? 0;
  return code >= 0x20 && code !== 0x7f && !FORBIDDEN_FILE_NAME_CHARACTERS.has(character);
}

function sanitizeFileName(text: string): string {
  const spaced = text.split(INDEXING_SEPARATOR).join(RECORD_TITLE_CODE_SEPARATOR).replace(/\s+/g, ' ');
  const kept = Array.from(spaced).filter(isFileNameCharacter).join('').replace(/ +/g, ' ').trim();
  return Array.from(kept).slice(0, FILE_NAME_MAX_LENGTH).join('').trim();
}

export function buildRecordPdfFileName(record: RecordTitleSource): string {
  const base = sanitizeFileName(recordTitleOf(record));
  return `${base === '' ? record.code : base}.pdf`;
}
